// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3vasM","vLegacy":"SelectSecondary_vLegacy__211_e","error":"SelectSecondary_error__18EZw","disabled":"SelectSecondary_disabled__mgqKP"};